import * as contextTypes from 'modulesV2/constants/context';
import * as uiTypes from 'modulesV2/constants/ui';

export function setModalId(modalId, options = {}) {
  return {type: uiTypes.MODAL_SET, modalId, options};
}

export function clearModal() {
  return {type: uiTypes.MODAL_SET};
}

export function setAriaHiddenMainContent(isMainContentAriaHidden) {
  return {
    type: uiTypes.SET_ARIA_HIDDEN_MAIN_CONTENT,
    isMainContentAriaHidden
  };
}

/**
 * Set context for user interactions. This value represents
 * the textset that a user is currently exploring, or has navigated from.
 */
export function setContext(data) {
  return {type: contextTypes.SET_CONTEXT, data};
}
